import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import AccountCircle from '@material-ui/icons/AccountCircle';
import TranslateIcon from '@material-ui/icons/Translate';
import WorkIcon from '@material-ui/icons/Work';
import { useSnackbar } from 'notistack';
import React from 'react';
import { Link } from 'react-router-dom';
import ButtonUI from '../../ui/ButtonUI';
import MenuDrawer from './../MenuDrawer';
import CompanySelector from './CompanySelector';
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            minHeight: '90px',
            boxShadow: 'none',
            paddingTop: '15px'
        },
        grow: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
            color: '#000'
        },
        colorDefault: {
            background: '#ffffff'
        },
        inputRoot: {
            color: 'inherit',
        },
        center:
        {
            height: '100%',
            'vertical-align': 'middle'
        },
        inputInput: {
            padding: theme.spacing(1, 1, 1, 7),
            transition: theme.transitions.create('width'),
            width: '100%',
            [theme.breakpoints.up('md')]: {
                width: 200,
            },
        },
        sectionDesktop: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
        },
        sectionMobile: {
            display: 'flex',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
    }),
);

interface HideButtons {
    hideMenu?: boolean,
    hideCultureSelector?: boolean,
    hideCompanySelector?: boolean
    hideProfileMenu?: boolean
}

export default function TopAppBar(props: HideButtons) {

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    //const [message, setMessage] = useState("");
    // const [messageAutoHideDuration, setMessageAutoHideDuration] = useState<null | number>(null);
    // const [openSnackbar, setOpenSnackbar] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const isMenuOpen = Boolean(anchorEl);

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const errorPopupFunc = () => {
        var buttonErrorPopup = document.getElementById("ErrorPopupButton");
        var message = "";
        if (buttonErrorPopup) message = buttonErrorPopup.innerText.replace(/(\r\n)|\r/g, '<br />');
        enqueueSnackbar(message, { variant: 'error' });
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>My account</MenuItem>
        </Menu>
    );

    return (
        <div className={classes.grow}>
            <ButtonUI id="ErrorPopupButton" style={{ display: "none" }} onClick={() => errorPopupFunc()}> </ButtonUI>
            <AppBar position="static" className={[classes.colorDefault, classes.root].join(' ')}>
                <Toolbar>
                    {!props.hideMenu && <MenuDrawer />}
                    <Link to="/">
                        <img src="/img/logo.png" alt="" />
                    </Link>
                    <div className={classes.grow} />
                    <div className={classes.sectionDesktop}>
                        {
                            !props.hideCultureSelector &&
                            <React.Fragment>
                                <IconButton aria-label="show 4 new mails" color="default">
                                    <TranslateIcon />
                                </IconButton>
                            </React.Fragment>
                        }
                        {
                            !props.hideCompanySelector &&
                            <React.Fragment>
                                <IconButton aria-label="show 4 new mails" color="default">
                                    <WorkIcon />
                                </IconButton>
                                <CompanySelector />
                            </React.Fragment>
                        }
                        {
                            !props.hideProfileMenu &&
                            <React.Fragment>
                                <IconButton
                                    edge="end"
                                    aria-label="account of current user"
                                    aria-controls={menuId}
                                    aria-haspopup="true"
                                    onClick={handleProfileMenuOpen}
                                    color="default"
                                >
                                    <AccountCircle />
                                </IconButton>
                            </React.Fragment>
                        }
                    </div>
                    {/* <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="default"
            >
              <MoreIcon />
            </IconButton>
          </div> */}
                </Toolbar>
            </AppBar>
            {/* {renderMobileMenu} */}
            {renderMenu}
        </div>
    );
}
